window.luiReferenceControllers = window.luiReferenceControllers || [];
    window.luiReferenceControllers.push(function (application, Stimulus) {
        application.register("references_helicopter_alliance_web", class extends Stimulus.Controller {
            connect() {
                console.log('vrtulníčky connect')

                const self = this;
            }

            playVideo({currentTarget}) {
                console.log('vrtulníčky playVideo')
                arguments[0].preventDefault()

                const video = currentTarget.closest('[data-ref="video"]').querySelector('video');

                if(video !== null) {
                    video.setAttribute('controls','')
                    video.play()
                    currentTarget.style.opacity = 0
                    currentTarget.style.pointerenter = 'none'
                }
            }

            resetVideo({currentTarget}) {
                console.log('vrtulníčky resetvideo')
                const button = currentTarget.closest('[data-ref="video"]').querySelector('[data-ref="playButton"]');
                currentTarget.removeAttribute('controls')
                currentTarget.currenttime = 0

                if(button !== null) {
                    button.style.opacity = null
                    button.style.pointerenter = null
                }
            }
        })
    });
    window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
